import { Accordion, AccordionItem, Collapse, Row } from 'reactstrap';
import classnames from 'classnames';
import { useEffect, useState } from 'react';
import { useMatch } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { formatUSD } from '../../../../../../helpers/helpers';
import { getFlipMeInfo } from '../../../slice';
import { Tile } from '../../../../../../Components/Custom/Tile';

import { FlipMeHub } from '../FlipMeHub';

export const FlipMe = () => {
  const { flipMe } = useAppSelector((state) => state.userDetails);

  const [col, setCol] = useState(true);

  const t_col = () => {
    setCol(!col);
  };

  const dispatch = useAppDispatch();

  const match = useMatch('/users/:id/*');
  const userId = match?.params.id;

  useEffect(() => {
    if (flipMe !== null) return;
    dispatch(getFlipMeInfo(Number(userId)));
  }, [flipMe]);

  return (
    <div>
      <h5>My FlipMe Summary</h5>
      <Row>
        <Tile label='Total FLIPME orders'>
          {formatUSD(flipMe?.summary?.totalOrderAmount)}
          <span className='text-muted fs-14'> USDT</span>
        </Tile>
      </Row>

      <Accordion open={'3'}>
        <AccordionItem>
          <h2 className='accordion-header' id='headingTwo'>
            <button
              className={classnames('accordion-button', { collapsed: !col })}
              type='button'
              onClick={t_col}
              style={{ cursor: 'pointer' }}>
              My FlipMe Cards
            </button>
          </h2>
          <Collapse isOpen={col} className='accordion-collapse'>
            <div className='accordion-body'>
              {flipMe?.userPackages?.map((data, i) => (
                <FlipMeHub key={i} data={data} />
              ))}
            </div>
          </Collapse>
        </AccordionItem>
      </Accordion>
    </div>
  );
};
